import TwoColumnLayout from '../layouts/TwoColumnLayout'
import Sidebar from "../components/leftContent/Sidebar";
import iconApps from "../assets/img/icon-apps.png";

export default function Apps({rightContent}) {
    return (
        <TwoColumnLayout leftContent={<Sidebar/>} rightContent={rightContent} icon={iconApps} key={rightContent}/>
    )
}

